import Template from './template';
 
function Index() {
    return (
      <Template />
    );
 
}

export default Index;